var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchSubmit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15.689,
  height: 15.689
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "search-submit_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#04040F",
  d: "M0 0h15.689v15.689H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#04040F",
  clipPath: "url(#search-submit_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 67",
  d: "M14.175 7.839 7.313.977"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 68",
  d: "m14.175 7.839-6.862 6.862"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 23",
  d: "M1.846 8.02h12.28"
}))));
export default SvgSearchSubmit;